import React from 'react';

function Footer() {
  return (
    <footer>
      <p>D-nesh's Portfolio</p>
      <p>2026</p>
    </footer>
  );
}

export default Footer;
